import { render } from "./OverviewSection.vue?vue&type=template&id=7d68809c&scoped=true"
const script = {}

import "./OverviewSection.vue?vue&type=style&index=0&id=7d68809c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d68809c"]])

export default __exports__